export const fastTransitionDuration = '0.15s';
export const regularTransitionDuration = '0.3s';

export const loadingIndicationDelay = '0.2s';
